import { render } from "./animatedModal.vue?vue&type=template&id=473e2405"
import script from "./animatedModal.vue?vue&type=script&lang=js"
export * from "./animatedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__